type InputNode = {
  id: number;
  title: string;
  routeName?: string;
  position: number;
  isDisplayed: boolean;
  lvl: number;
  children: InputNode[];
  root: string;
};

// type OutputNode = {
//   title: string;
//   key: string;
//   children?: OutputNode[];
// };

export const formatMenuTreeData = (data: InputNode[]): any[] => {
  return data.map((node, key: number) => ({
    title: node.title,
    key: node?.children?.length
      ? node.routeName?.concat(key.toString())
      : node.routeName || node.position.toString(),
    children: node?.children.length
      ? [
          ...(node?.children?.[0]?.children?.length
            ? []
            : [{ title: `Liste`, key: node.routeName }]),
          ...formatMenuTreeData(node?.children),
        ].filter((item) => Object.keys(item).length)
      : [],
  }));
};
